import {MatrixClient} from 'matrix-js-sdk';

export const ignoreUser = (
  client: MatrixClient,
  userId: string
): Promise<void> => {
  const ignoredUsers = [...client.getIgnoredUsers()];
  const i = ignoredUsers.findIndex((u) => u === userId);
  if (i < 0) {
    ignoredUsers.push(userId);
  }
  return client.setIgnoredUsers(ignoredUsers).then(() => undefined);
};
